import { MapPin, Phone, Mail } from "lucide-react";
import { useLang } from "@/i18n";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  const { t } = useLang();

  const links = [
    ["services", t.nav.services],
    ["manifesto", t.nav.dna],
    ["avis", t.nav.reviews],
    ["faq", t.nav.faq],
    ["contact", t.nav.contact],
  ];

  return (
    <footer data-testid="footer-section" className="bg-[#0E1B2A] pt-16 pb-8 text-[#FAF8F5]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <p className="font-display text-xl font-semibold tracking-[0.18em]">
              SERVICE<span className="text-[#C87A57]">+</span>
            </p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#FAF8F5]/60">{t.footer.tagline}</p>
            <p data-testid="footer-partners" className="mt-5 text-xs font-semibold uppercase tracking-[0.2em] text-[#D4AF37]">
              Partenaire officiel Interhome
            </p>
            <p className="mt-6 max-w-md text-xs leading-relaxed text-[#FAF8F5]/40">
              Entreprise de nettoyage à Nice Ouest (Saint-Isidore, Saint-Roman-de-Bellet, L'Arenas) — interventions à Nice, Saint-Laurent-du-Var, Cagnes-sur-Mer, Antibes, Cannes et sur toute la Côte d'Azur : ménage Airbnb, nettoyage fin de séjour, housekeeping hôtelier, blanchisserie, gestion locative et conciergerie.
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#FAF8F5]/45">{t.footer.contactTitle}</p>
            <ul className="mt-5 space-y-3.5 text-sm">
              <li>
                <a data-testid="footer-address" href="https://maps.google.com/?q=13+rue+Berthe+Morisot+06200+Nice" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-[#FAF8F5]/75 transition-colors hover:text-[#D4AF37]">
                  <MapPin size={15} className="shrink-0 text-[#C87A57]" />
                  {t.contact.address}
                </a>
              </li>
              <li>
                <a data-testid="footer-phone" href="tel:+33767473293" className="flex items-center gap-3 text-[#FAF8F5]/75 transition-colors hover:text-[#D4AF37]">
                  <Phone size={15} className="shrink-0 text-[#C87A57]" />
                  07 67 47 32 93
                </a>
              </li>
              <li>
                <a data-testid="footer-email" href="mailto:topserv06@gmail.com" className="flex items-center gap-3 text-[#FAF8F5]/75 transition-colors hover:text-[#D4AF37]">
                  <Mail size={15} className="shrink-0 text-[#C87A57]" />
                  topserv06@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#FAF8F5]/45">{t.footer.navTitle}</p>
            <ul className="mt-5 space-y-3 text-sm">
              {links.map(([id, label]) => (
                <li key={id}>
                  <button data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="text-[#FAF8F5]/75 transition-colors hover:text-[#D4AF37]">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-7 text-xs text-[#FAF8F5]/45 sm:flex-row">
          <p data-testid="footer-siret">SIRET 75396469100020 · {t.footer.created} · {t.footer.team}</p>
          <p>© 2025-2026 Service Plus — {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
